"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/dropdown/style");
var _dropdown = _interopRequireDefault(require("antd/lib/dropdown"));
require("antd/lib/tag/style");
var _tag = _interopRequireDefault(require("antd/lib/tag"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("../../../../../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SearchInputWithFilters = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var onSearch = _ref.onSearch,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? _lodash.noop : _ref$onFocus,
    loading = _ref.loading,
    additionalClass = _ref.additionalClass,
    onKeyDown = _ref.onKeyDown,
    onChange = _ref.onChange,
    onClear = _ref.onClear,
    searchContext = _ref.searchContext,
    contextDropdownMenu = _ref.contextDropdownMenu,
    showContextDropdown = _ref.showContextDropdown,
    searchDropdownMenu = _ref.searchDropdownMenu,
    currentConfigItem = _ref.currentConfigItem,
    inputText = _ref.inputText,
    value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-search__input__wrapper ".concat(additionalClass)
  }, /*#__PURE__*/_react.default.createElement(_input.default.Search, {
    className: "channel-search__input",
    placeholder: searchContext ? currentConfigItem.placeholder : 'Search the channel',
    onSearch: onSearch,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onChange: onChange,
    loading: loading,
    ref: ref,
    value: value
  })), /*#__PURE__*/_react.default.createElement(_components.Icon, {
    className: (0, _classnames.default)('search-clear-icon', 'cursor-pointer', {
      hidden: !value && !searchContext
    }),
    type: "close-bubble-filled",
    viewBoxSize: 16,
    onClick: onClear
  }), /*#__PURE__*/_react.default.createElement(_tag.default, {
    className: (0, _classnames.default)('search-context-tags', {
      'tags-present': searchContext
    }, {
      hidden: !searchContext
    })
  }, "".concat(searchContext, ":")), /*#__PURE__*/_react.default.createElement(_dropdown.default, {
    placement: "bottomLeft",
    overlay: contextDropdownMenu,
    trigger: ['click'],
    className: "search-context-dropdown",
    visible: showContextDropdown && !inputText,
    children: /*#__PURE__*/_react.default.createElement("div", null)
  }), /*#__PURE__*/_react.default.createElement(_dropdown.default, {
    placement: "bottomCenter",
    overlay: searchDropdownMenu,
    trigger: ['click'],
    className: "selected-search-context-dropdown",
    visible: !!(currentConfigItem !== null && currentConfigItem !== void 0 && currentConfigItem.searchDropDownVisible),
    children: /*#__PURE__*/_react.default.createElement("div", null)
  }));
});
var _default = SearchInputWithFilters;
exports.default = _default;